var getEstimatedShippingMethods_gql_default = `
query GetEstimatedShippingMethods($cartId: String, $address: CustomerAddressInput) {
  WmEstimateShippingMethods(cartId: $cartId, address: $address) {
    items {
      amount
      available
      carrier_code
      carrier_title
      error_message
      method_code
      method_title
      price_excl_tax
      price_incl_tax
    }
  }
}
`;
export {
  getEstimatedShippingMethods_gql_default as default
};
